// extracted by mini-css-extract-plugin
export default {"details":"DeviceDetails_details__Q2vSK","content":"DeviceDetails_content__Q7AwH"};